module.exports = __webpack_public_path__ + "prod/1.42.2/img/new-mode-four.ac97b6be.png";